var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui padded basic segment"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.posVref),
      expression: "posVref",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.posVref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.posVref = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.portValue),
      expression: "portValue",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "adc-dac-range",
      "max": "255"
    },
    domProps: {
      "value": (_vm.portValue)
    },
    on: {
      "__r": function($event) {
        _vm.portValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.vin),
      expression: "vin",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "vin",
      "min": _vm.negVref,
      "max": _vm.posVref,
      "step": "any"
    },
    domProps: {
      "value": (_vm.vin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vin = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.negVref),
      expression: "negVref",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "negVref"
    },
    domProps: {
      "value": (_vm.negVref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.negVref = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portNum),
      expression: "portNum"
    }],
    attrs: {
      "id": "port-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.portNum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(i) {
    return _c('option', {
      domProps: {
        "value": i - 1
      }
    }, [_vm._v("Port " + _vm._s(i - 1))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eac95cb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdcDacSlider.vue
// module id = 118
// module chunks = 1